import api from "../utils/axios/axiosConfig";

const adAccountsService = {
  create: (data) => api.post("/ad-accounts/create", data),

  update: (id, data) => api.put(`/ad-accounts/update/${id}`, data),

  delete: (id) => api.delete(`/ad-accounts/delete/${id}`),

  get: (id) => api.get(`/ad-accounts/get/${id}`),

  search: (params) => api.post("/ad-accounts/search", params),

  changeStatus: (id, data) =>
    api.put(`/ad-accounts/change_status/${id}`, data),

  reshareBM: (adAccountId, data) =>
    api.put(`/ad-accounts/reshareBM/${adAccountId}`, data),

  changeName: (adAccountId, data) =>
    api.put(`/ad-accounts/changeName/${adAccountId}`, data),

  updateIdentifierDecision: (data) =>
    api.patch("/ad-accounts/identifier-decision", data),
};

export default adAccountsService;
